import React from 'react'
import AuthorizationRequired from '../../../svg/AuthorizationRequired'
import {Stack} from '@mui/material'
import Label from '../../customTable/Label'

export default function Error403() {
  return (
    <Stack
      gap='25px'
      alignItems={'center'}
      justifyContent={'center'}
      minHeight={'50vh'}
      width={'100%'}
    >
      <AuthorizationRequired />
      <Label
        align='center'
        fs={{xs: '30px', sm: '50px'}}
        fw='500'
        color='#405189'
        text='authorizationRequired'
      />
    </Stack>
  )
}
